import {
    Typography,
    Input,
    Button,
    IconButton,
    Select,
    Option,
    Tooltip
} from "@material-tailwind/react";
import {
    faSearch,
    faMobileRetro,
    faA,
    faDownload,
    faCapsules
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useStore } from "../store/Zustand";
import { useAuth } from "../store/auth";
import { SEARCH_REFILL, MEDICINE_LIST } from "../Constants";
import { useEffect, useState } from "react";
import RefillData from "./RefillData";
import axios from "../api/axios";
import { useNavigate } from "react-router";
import { pdf } from "@react-pdf/renderer";
import PrintSheet from "./PrintSheet";
import PrintMedList from "./PrintMedList";

export default function Refill() {

    const token = useAuth((state) => state.token);
    const resetAuth = useAuth((state) => state.resetAuth);

    // const setTrigger = useStore((state) => state.setTrigger);

    const setSearch = useStore((state) => state.setSearch);
    const searchState = useStore((state) => state.searchState);

    // const refill_list = useStore((state) => state.refill_list);
    const setRefillList = useStore((state) => state.setRefillList);

    const pdfData = useStore((state) => state.pdfData);
    const setPdfData = useStore((state) => state.setPdfData);

    const medList = useStore((state) => state.medList);
    const setMedList = useStore((state) => state.setMedList);

    const currentDate = new Date().toISOString().split("T")[0];

    const currentPage = useStore((state) => state.currentPage);
    const pageSize = useStore((state) => state.pageSize);
    const setTotalPages = useStore((state) => state.setTotalPages);

    const [pdfBlob, setPdfBlob] = useState(false);
    // const [test, setTest] = useState(true);


    const [formData, setFormData] = useState({
        searchTerm: "",
        fromDate: currentDate,
        toDate: currentDate,
        status: ""
    });

    const downloadPdf = async () => {
        const fromDate = new Date(formData.fromDate);
        const toDate = new Date(formData.toDate);

        const next_from_date = new Date(fromDate);
        next_from_date.setDate(fromDate.getDate() + 7);

        const next_to_date = new Date(toDate)
        next_to_date.setDate(toDate.getDate() + 7);

        const dateDiff = Math.floor((toDate - fromDate) / (1000 * 3600 * 24));

        if (dateDiff > 31) {
            alert("The date range cannot exceed 31 days.");
            return;
        }
        const pdfInstance = pdf(
            <PrintSheet
                analytics={{
                    formData,
                    next_from_date: next_from_date.toISOString().split("T")[0],
                    next_to_date: next_to_date.toISOString().split("T")[0],
                    pdfData
                }}
            />
        );
        const pdfBlob = await pdfInstance.toBlob();
        setPdfBlob(pdfBlob);
        if (pdfBlob) {
            const url = URL.createObjectURL(pdfBlob);
            const a = document.createElement("a");
            const currentDate = new Date();
            const fileName = `remindersheet_${currentDate.toLocaleString()}.pdf`;
            a.href = url;
            a.download = fileName;
            a.click();
            URL.revokeObjectURL(url);
        }
    };

    const downloadMedPdf = async (data) => {
        // console.log(medList)
        const fromDate = new Date(formData.fromDate);
        const toDate = new Date(formData.toDate);
        const dateDiff = Math.floor((toDate - fromDate) / (1000 * 3600 * 24));

        if (dateDiff > 31) {
            alert("The date range cannot exceed 31 days.");
            return;
        }
        const pdfInstance = pdf(
            <PrintMedList
                analytics={{
                    formData,
                    data
                }}
            />
        );
        const pdfBlob = await pdfInstance.toBlob();
        setPdfBlob(pdfBlob);
        if (pdfBlob) {
            const url = URL.createObjectURL(pdfBlob);
            const a = document.createElement("a");
            const currentDate = new Date();
            const fileName = `medsheet_${currentDate.toLocaleString()}.pdf`;
            a.href = url;
            a.download = fileName;
            a.click();
            URL.revokeObjectURL(url);
        }
    };

    const navigate = useNavigate();

    // const searchRefills = async () => {
    //     const reqData = {
    //         search_type: searchState,
    //         first_name: searchState === 0 ? formData.searchTerm : "",
    //         mobile_number: searchState === 1 ? formData.searchTerm : "",
    //         carefill_status: formData.status !== "" ? formData.status : 5,
    //         from_date: formData.fromDate,
    //         to_date: formData.toDate,
    //         page: currentPage,
    //         page_size: pageSize
    //     };

    //     try {
    //         if (token !== "" && formData !== "") {
    //             const response = await axios.get(SEARCH_REFILL, {
    //                 headers: {
    //                     "x-access-tokens": token,
    //                     "Content-Type": "application/json",
    //                 },
    //                 params: reqData,
    //             });

    //             if (response.status === 200) {
    //                 setRefillList(response.data.data);
    //                 // console.log("-----------", response.data)
    //                 setTotalPages(response.data.pageInfo.totalPages || 1);
    //                 const totalPages = response.data.pageInfo.totalPages;
    //                 let allRefills = [];
    //                 for (let page = 1; page <= totalPages; page++) {
    //                     const fullDataResponse = await axios.get(SEARCH_REFILL, {
    //                         headers: {
    //                             "x-access-tokens": token,
    //                             "Content-Type": "application/json",
    //                         },
    //                         params: {
    //                             ...reqData,
    //                             page: page,
    //                         },
    //                     });

    //                     if (fullDataResponse.status === 200) {
    //                         allRefills = allRefills.concat(fullDataResponse.data.data);
    //                     }
    //                 }
    //                 // console.log("all refills:", allRefills)
    //                 setPdfData(allRefills);
    //             } else {
    //                 alert("Failed to fetch refills [1]");
    //             }
    //         } else if (token !== "" && formData === "") {
    //             alert("Please provide a valid value");
    //         }
    //     } catch (err) {
    //         if (err?.response?.data?.status_message) {
    //             alert(err?.response?.data?.status_message);
    //         } else if (err.response.status === 401) {
    //             alert("Session Expired");
    //             resetAuth();
    //         } else if (err.response.status === 403) {
    //             alert(err.response.data.status_message);
    //             resetAuth();
    //             navigate("/generateOTP");
    //         } else {
    //             alert(err.response.data.status_message);
    //         }
    //     }
    // };

    const searchRefills = async () => {
        const reqData = {
            search_type: searchState,
            first_name: searchState === 0 ? formData.searchTerm : "",
            mobile_number: searchState === 1 ? formData.searchTerm : "",
            carefill_status: formData.status !== "" ? formData.status : 5,
            from_date: formData.fromDate,
            to_date: formData.toDate,
            page: currentPage,
            page_size: pageSize
        };

        try {
            if (token && formData) {
                // Fetch the first page
                const response = await axios.get(SEARCH_REFILL, {
                    headers: {
                        "x-access-tokens": token,
                        "Content-Type": "application/json",
                    },
                    params: reqData,
                });

                if (response.status === 200) {
                    const { data, pageInfo } = response.data;
                    setRefillList(data);
                    // console.log("-----", data)
                    setTotalPages(pageInfo.totalPages || 1);

                    const totalPages = pageInfo.totalPages;

                    // Parallel fetch all pages for export (PDF or other use)
                    const pageRequests = [];
                    for (let page = 1; page <= totalPages; page++) {
                        pageRequests.push(
                            axios.get(SEARCH_REFILL, {
                                headers: {
                                    "x-access-tokens": token,
                                    "Content-Type": "application/json",
                                },
                                params: {
                                    ...reqData,
                                    page: page,
                                },
                            })
                        );
                    }

                    const results = await Promise.all(pageRequests);

                    let allRefills = [];
                    results.forEach(res => {
                        if (res.status === 200) {
                            allRefills = allRefills.concat(res.data.data);
                        }
                    });

                    setPdfData(allRefills);

                } else {
                    alert("Failed to fetch refills [1]");
                }

            } else if (token && !formData) {
                alert("Please provide a valid value");
            }

        } catch (err) {
            if (err?.response?.data?.status_message) {
                alert(err.response.data.status_message);
            } else if (err.response?.status === 401) {
                alert("Session Expired");
                resetAuth();
            } else if (err.response?.status === 403) {
                alert(err.response.data.status_message);
                resetAuth();
                navigate("/generateOTP");
            } else {
                alert(err.response.data.status_message);
            }
        }
    };

    const printMedicineList = async () => {
        try {
            if (token !== "" && formData !== "") {
                const reqData = {
                    from_date: formData.fromDate,
                    to_date: formData.toDate,
                };

                const response = await axios.get(MEDICINE_LIST, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-tokens": token,
                    },
                    params: {
                        ...reqData,
                    },
                });
                if (response.status === 200) {
                    // console.log("-----", response.data.data)
                    setMedList(response.data.data)
                    downloadMedPdf(response.data.data)
                } else {
                    alert(response.data.status_message)
                }
            }
            else if (token !== "" && formData === "") {
                alert("please provide a valid value")
            }
        }
        catch (err) {
            if (err?.response?.data?.status_message) {
                alert(err?.response?.data?.status_message);
            } else if (err.response.status === 500) {
                alert(err.response.data.status_message);
            } else if (err.response.status === 400) {
                alert(err.response.data.status_message);
            } else if (err.response.status === 403) {
                alert(err.response.data.status_message)
                resetAuth()
                navigate("/generateOTP")
            } else {
                alert(err.response.data.status_message);
            }
        }

    }

    useEffect(() => {
        searchRefills();
    }, [currentPage, pageSize]);
    return (
        <>
            <div className="grid min-w-full lg:justify-center md:justify-center sm:justify-between">
                <span className="h-min text-center my-5 lg:ml-0 md:ml-0 sm:ml-[5px]">
                    <Typography variant="h3" className="sm:text-2xl md:text-3xl lg:text-4xl text-center">Refill Management Sheet</Typography>
                </span>
                <div className="flex flex-wrap w-screen sm:px-4 md:px-14 lg:px-14">
                    <div className="flex flex-wrap sm:flex-col md:flex-row lg:flex-row sm:gap-y-2 md:gap-x-4 lg:gap-x-6 justify-center items-center w-full h-min">
                        <div className="sm:w-full md:w-96 lg:w-96">
                            <Input
                                label="Name or Phone number"
                                color="blue"
                                icon={<FontAwesomeIcon icon={faSearch} />}
                                onChange={(e) => setFormData(prev => ({ ...prev, searchTerm: e.target.value }))}
                                value={formData.searchTerm}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        searchRefills();
                                    }
                                }}
                            />
                        </div>
                        <div className="flex flex-row items-center justify-center">
                            <IconButton
                                color={searchState !== 0 ? "blue" : "gray"}
                                onClick={() => setSearch(1)}
                                ripple={false}
                            >
                                <FontAwesomeIcon icon={faMobileRetro} size="2x" />
                            </IconButton>
                            <IconButton
                                color={searchState !== 1 ? "blue" : "gray"}
                                onClick={() => setSearch(0)}
                                ripple={false}
                            >
                                <FontAwesomeIcon icon={faA} size="2x" />
                            </IconButton>
                        </div>
                        <div className="sm:w-full md:w-auto lg:w-auto flex justify-center">
                            <Select
                                size="md"
                                label="Select Status"
                                color="blue"
                                value={formData.status}
                                onChange={(val) => setFormData(prev => ({ ...prev, status: val }))}
                            >
                                <Option value="0">Unprocessed</Option>
                                <Option value="1">Snooze</Option>
                                <Option value="2">Confirm</Option>
                                <Option value="3">Dispatched</Option>
                                <Option value="4">Stop</Option>
                                <Option value="5">All</Option>
                            </Select>
                        </div>
                    </div>
                    <div className="flex justify-center w-full pt-4">
                        <div className="flex flex-col gap-2 justify-center sm:w-72 md:w-60 lg:w-60 text-center">
                            <Input
                                label="Alert From Date"
                                type="date"
                                color="blue"
                                value={formData.fromDate}
                                onChange={(e) =>
                                    setFormData((prev) => ({ ...prev, fromDate: e.target.value }))
                                }
                            />
                            <Input
                                label="Alert To Date"
                                type="date"
                                color="blue"
                                value={formData.toDate}
                                onChange={(e) =>
                                    setFormData((prev) => ({ ...prev, toDate: e.target.value }))
                                }
                            />
                            <div className="flex flex-row justify-center mt-2 gap-1">
                                <Button onClick={searchRefills} className="w-16" color="blue">
                                    <span className="text-center">Go</span>
                                </Button>
                                <Tooltip content="Reminder Date Report">
                                    <Button onClick={downloadPdf} className="w-16 text-md" color="blue">
                                        <FontAwesomeIcon icon={faDownload} />
                                    </Button>
                                </Tooltip>
                                <Tooltip content="Medicine List Report">
                                    <Button onClick={printMedicineList} className="w-16 text-md" color="blue">
                                        <FontAwesomeIcon icon={faCapsules} />
                                    </Button>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-full max-h-min">
                    <RefillData />
                </div>
            </div>
        </>
    )
}